const IllustrationContent = {
    data: [
        {
            label: '保單借款',
            value: 'loan',
            list: [
                {
                    title: '保單借款',
                    code: 'Pon4300',
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁，點選保單借款',

                        },
                        {
                            content: '請詳閱「保險單借款約定條款及重要事項告知」，閱讀完成請點選「本人已閱讀並同意」',

                        },
                        {
                            content: '閱讀「借款人權益說明」，閱讀完成點選「本人已閱讀並瞭解」',

                        },
                        {
                            content: '確認行動電話及E-mail是否為最新資訊，若要變更，請點選變更輸入；確認無誤，請點選「確定」',

                        },
                        {
                            content: '選擇欲借款保單幣別，將依所選幣別顯示可借款保單',

                        },
                        {
                            content: '輸入欲借款金額及匯款帳號，輸入完成後點選「下一步」',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '確認無誤，點選「確定」，進入輸入動態密碼頁' },
                            ],

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次借款申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
            ],
        },
        {
            label: '投資內容',
            value: 'investment',
            list: [
                {
                    title: '目標/計畫保費、配置比例暨繳別變更',
                    code: 'A1',
                    grayContent: {
                        title: '依可辦理保單提供項目如下：',
                        ol: [
                            {
                                text: '每期目標/計畫保費金額變更 '
                            },
                            {
                                text: '每期目標/計畫保費投資的標的或配置的比例變更'
                            },
                            {
                                text: '繳別變更'
                            }

                        ],
                        otherText: [
                            {
                                text: '單項變更如需補費預計於繳費成功後3~5個工作天完成'
                            }
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '點選「投資型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「目標/計畫保費、配置比例暨繳別變更」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '「目標/計畫保費、配置比例暨繳別變更」之相關警語，閱讀完成請點選「確定」',

                        },
                        {
                            content: '欲辦理變更之項目，請點選「變更」，若欲刪除該項目變更，可點選「取消變更」，輸入完成點選「下一步」',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入選擇補/退費方式頁' },
                            ],

                        },
                        {
                            content: '選擇欲補費方式，選擇完成後點選「下一步」，進入輸入動態密碼頁',

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '部份投資終止',
                    code: 'A7',
                    grayContent: {
                        title: '',
                        ol: [
                            {
                                text: '依可辦理保單提供減少投資標的之單位數以提取部分保單帳戶價值，提取保單帳戶價值之部分視為本契約之部分投資終止。'
                            },

                        ],
                        otherText: [
                            {
                                text: '單項變更預計於4~6個工作天完成'
                            },
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '點選「投資型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「部分投資終止」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '「部分投資終止」之相關警語，閱讀完成請點選「確定」',

                        },
                        {
                            content: '欲辦理贖回之基金標的，請點選「贖回」',

                        },
                        {
                            content: '可點選「依單位數」或依「依比例」後輸入，若欲刪除已輸入之贖回資料，可點選「取消變更」，待輸入完成點選「下一步」，下方顯示數值為預估贖回金額(依商品幣別)',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入選擇補/退費方式頁' },
                            ],

                        },
                        {
                            content: '選擇欲退費方式，選擇完成後點選「下一步」，進入輸入動態密碼頁',

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '投資標的轉換',
                    code: 'A6',
                    grayContent: {
                        title: '',
                        ol: [
                            {
                                text: '依可辦理保單提供將其投資之投資標的價值轉換至其他可供保費配置之投資標的。'
                            },

                        ],
                        otherText: [
                            {
                                text: '單項變更預計於5~7個工作天完成'
                            },
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '點選「投資型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「投資標的轉換」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '「投資標的轉換」之相關警語，閱讀完成請點選「確定」',

                        },
                        {
                            content: '輸入欲轉出之標的，針對欲辦理轉出之標的，點選「轉出」，並點選「依單位數」或依「依比例」後輸入',

                        },
                        {
                            content: '輸入欲轉入之標的，針對欲辦理轉入之基金輸入配置比例，若要選擇一筆以上，可點選「新增一筆」',
                            circleOl: [
                                { text: '頁面下方會顯示目前剩餘可分配比例，剩餘可分配比例需為0%' },
                                { text: '輸入完成後，點選「下一步」' }
                            ],

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入輸入動態密碼頁' },
                            ],

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '指定扣取每月費用之順序',
                    code: 'AF',
                    grayContent: {
                        title: '依可辦理保單提供項目如下：',
                        ol: [
                            {
                                text: '指定投資標的扣取每月費用之順序，將自約定生效後之保單週月日起於指定的投資標的價值中扣取'
                            },
                            {
                                text: '取消指定扣取每月費用之順序後，每月應扣取之費用，將依保單條款約定之順序扣取每月費用。'
                            }
                        ],
                        reminder: [
                            {
                                text: '1. 同一扣款順序僅能指定一檔基金。'
                            },
                            {
                                text: '2. 要保人未指定投資標的扣取每月費用之順序，或所指定之各投資標的價值於支付當月費用後尚有不足時，本公司仍依本契約約定之順序扣取每月費用。'
                            }
                        ],
                        otherText: [
                            {
                                text: '單項變更預計30分鐘內完成'
                            },
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '點選「投資型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「指定扣取每月費用之順序」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '輸入欲變更之內容，輸入完成後點選「下一步」',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入輸入動態密碼頁' },
                            ],

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '新台幣貨幣帳戶定期定額投資金額轉換',
                    code: 'A9',
                    grayContent: {
                        title: '依可辦理保單提供項目如下：',
                        ol: [
                            {
                                text: '新台幣貨幣帳戶定期定額投資標的轉換之申請'
                            },
                            {
                                text: '新台幣貨幣帳戶定期定額投資標的轉換之終止'
                            },
                            {
                                text: '新台幣貨幣帳戶定期定額投資標的轉換之指定轉換金額變更'
                            },
                            {
                                text: '新台幣貨幣帳戶定期定額投資標的轉換之配置變更'
                            },
                            {
                                text: '新台幣貨幣帳戶定期定額投資標的轉換之轉換日變更(註：指定之轉換日，若該月無此日期，則以該月的最後一個營業日作為該月之指定轉換日)'
                            },
                            {
                                text: '新台幣貨幣帳戶定期定額投資標的轉換補轉變更'
                            }
                        ],
                        reminderTitle: '注意事項：',
                        reminder: [
                            {
                                text: '1. 轉換當時，若指定買進的投資標的已停售，則按比例分配至其他未停售的投資標的。若全部買進的投資標的均已停售，則自動終止本項定期定額投資標的轉換。'
                            },
                            {
                                text: '2. 因辦理保全變更中或或有其他投資、扣除新台幣貨幣帳戶等作業未完成，致無法於指定轉換日進行轉換時，若勾選「同意」，則於上述作業完成後之次一工作日，始進行轉換；若勾選「不同意」，將取消當月投資標的轉換，但不計入失敗次數。'
                            },
                            {
                                text: '3. 同一保單年度內，不論本項定期定額投資標的轉換次數為何，僅計算一次轉換次數，且須與一般「投資標的轉換」一起累計轉換次數。'
                            },
                            {
                                text: '4. 轉換失敗一次即終止本次定期定額投資標的轉換，往後必須重新申請。'
                            }
                        ],
                        otherText: [
                            {
                                text: '單項變更預計30分鐘內完成'
                            },
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '依欲申請之保單類別點選「投資型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「新台幣貨幣帳戶定期定額投資金額轉換」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '「新台幣貨幣帳戶定期定額投資金額轉換」相關重要警語，閱讀完成請點選「確定」',

                        },
                        {
                            content: '輸入變更內容，輸入完成點選「下一步」',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入輸入動態密碼頁' },
                            ],

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '定期定額投資金額申請/變更',
                    code: 'A4',
                    grayContent: {
                        title: '依可辦理保單提供項目如下：',
                        ol: [
                            {
                                text: '定期定額投資之申請'
                            },
                            {
                                text: '定期定額投資之終止'
                            },
                            {
                                text: '定期定額投資指定扣款金額變更'
                            },
                            {
                                text: '定期定額投資標的配置變更'
                            },
                            {
                                text: '定期定額投資之指定扣款日變更'
                            }
                        ],
                        reminderTitle: '注意事項：',
                        reminder: [
                            {
                                text: '1. 本次所辦理之增額保費同意未來每個月以既有的金融機構帳戶轉帳/信用卡繳費，將以轉帳/請款成功日期為實際收到保險費之日。'
                            },
                            {
                                text: '2. 每月可以選擇5日、15日、25日轉帳扣款(每次僅請款一次)'
                            },
                            {
                                text: '3. 連續扣款失敗達三次、金融機構帳戶轉帳授權終止或信用卡為無效卡者，將停止定期定額投資，往後必須重新申請及金融機構/信用卡轉帳授權書授權成功後始得生效。'
                            }
                        ],
                        otherText: [
                            {
                                text: '單項變更預計30分鐘內完成'
                            },
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '依欲申請之保單類別點選「投資型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「定期定額投資金額申請/變更」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '「定期定額投資金額申請/變更」相關重要警語，閱讀完成請點選「確定」',

                        },
                        {
                            content: '輸入變更內容，輸入完成點選「下一步」',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入輸入動態密碼頁' },
                            ],

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '單筆增額/不定期投資金額申請',
                    code: 'A5',
                    grayContent: {
                        title: '依可辦理保單提供項目如下：',
                        ol: [
                            {
                                text: '單筆增額投資金額申請'
                            },
                            {
                                text: '彈性繳投資金額申請'
                            }
                        ],
                        reminderTitle: '注意事項：',
                        reminder: [
                            {
                                text: '1. 若此次補繳保費來源是以貸款或保單借款的金額再單筆追加投資型保單的保費，可能會因為這種循環財務槓桿操作方式而擴張個人信用，而且投資的淨值會隨著市場波動，當淨值跌的時候，可能會有損失，若無法償還您的貸款或借款本息時，可能會影響您的信用。'
                            },
                            {
                                text: '2. 保單的帳戶價值可能因為費用收取、匯率波動或投資績效變動等因素，其帳戶價值可能造成損失或降低為零時，除了保單有停效或終止的風險外，未來領回的金額可能低於您所需償還的貸款或保單借款金額。'
                            },
                            {
                                text: '3. 若此次補繳保費來源是以公司或其他同業辦理的保單終止契約(解約)時，有可能會有相關權益影響，例如：解約金的損失、再購買新保單時因年齡增長而使保費提高、超過投保年齡上限或身體狀況影響導致可能無法投保、違反告知義務解除契約的除斥期間及健康險的等待期，都要重新計算等。'
                            },
                            {
                                text: '4. 為維護您的權益，後續可能將有專人進行電話確認，造成不變，敬請見諒。'
                            }
                        ],
                        otherText: [
                            {
                                text: '單項變更預計30分鐘內完成'
                            },
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '依欲申請之保單類別點選「投資型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「單筆增額/不定期投資金額申請」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '「單筆增額/不定期投資金額申請」相關重要警語，閱讀完成請點選「確定」',

                        },
                        {
                            content: '輸入變更內容，輸入完成點選「下一步」',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入選擇補/退費方式頁' },
                            ],

                        },
                        {
                            content: '選擇欲補費方式，選擇完成後點選「下一步」，進入輸入動態密碼頁',

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '保費緩繳',
                    code: 'A2',
                    grayContent: {
                        title: '依可辦理保單提供項目如下：',
                        ol: [
                            {
                                text: '申請保費緩繳：選擇暫停繳費，將自下次收費日起停止收費，定期定額轉帳投資會同時暫停扣款。'
                            },
                            {
                                text: '終止保費緩繳：選擇恢復繳費，本次應先補收當期保費並自下次繳費日起恢復收費；定期定額轉帳投資會同時啟動扣款。若不要繳付定期定額者，請一併辦理定期定額終止。'
                            }

                        ],
                        otherText: [
                            {
                                text: '單項變更預計30分鐘內完成'
                            },
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '點選「投資型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「保費緩繳」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '輸入欲辦理之變更內容，輸入完成後，點選「下一步」，進入確認輸入資料頁',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入選擇補/退費方式頁' },
                            ],

                        },
                        {
                            content: '選擇欲補費方式，選擇完成後點選「下一步」，進入輸入動態密碼頁',

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '投資配息/提解給付方式變更',
                    code: 'AG',
                    grayContent: {
                        title: '',
                        ol: [
                            {
                                text: '提供投資標的之配息/提解給付方式變更，若約定給付方式為現金給付，須同時填寫要保人指定匯款帳戶。'
                            },
                        ],
                        otherText: [
                            {
                                text: '單項變更預計30分鐘內完成'
                            },
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '點選「投資型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「投資配息/提解給付方式變更」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '輸入欲辦理之變更內容，輸入完成後，點選「下一步」',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入輸入動態密碼頁' },
                            ],

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
            ],
        },
        {
            label: '基本資料',
            value: 'userData',
            list: [
                {
                    title: '要保人聯絡資訊變更',
                    code: 'BD',
                    grayContent: {
                        title: '提供項目如下：',
                        ol: [
                            {
                                text: '收費地址/電話變更'
                            },
                            {
                                text: '要保人住所（戶籍地址）/電話變更'
                            },
                            {
                                text: '要保人行動電話變更'
                            },
                            {
                                text: '要保人電子信箱變更'
                            },

                        ],
                        reminder: [
                            {
                                text: '1. 相關地址不可變更為郵政信箱。'
                            },
                            {
                                text: '2. 本次申請變更內容將同時更新以您為要保人於本公司所投保之所有個人險有效及停效保單。'
                            }
                        ],
                        otherText: [
                            {
                                text: '單項變更預計30分鐘內完成'
                            }
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁，點選要保人聯絡資訊',

                        },
                        {
                            content: '確認行動電話及E-mail是否為要保人最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '依欲辦理變更之聯絡資訊類別，點選「變更」，於下方輸入框輸入變更資料，輸入完成後請按「確定」',

                        },
                        {
                            content: '確認本次變更是否同意授權本公司傳送至其他保險公司申辦相同項目變更',
                            circleOl: [
                                { text: '點選同意，請勾選欲傳送之保險公司及審閱保全契約變更申請轉送暨個資蒐集同意書，並點選☐已閱讀並同意以上「保全契約變更申請轉送暨個資蒐集同意書」之告知事項，點選『下一步』' },
                                { text: '點選不同意，即進入確認輸入資料頁' }
                            ],

                        },
                        {
                            content: '確認無誤，點選「確定」，進入輸入動態密碼頁',

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '地址/電話/E-mail變更',
                    code: 'BC',
                    grayContent: {
                        title: '提供項目如下：',
                        ol: [
                            {
                                text: '收費地址/電話變更'
                            },
                            {
                                text: '要保人住所（戶籍地址）/電話/行動電話/電子信箱變更'
                            },
                            {
                                text: '被保險人住所/電話/行動電話變更'
                            },
                        ],
                        reminder: [
                            {
                                text: '相關地址不可變更為郵政信箱。'
                            }
                        ]
                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '依欲申請之保單類別點選「傳統型保單」或「投資型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「地址/電話/E-mail」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '輸入變更內容，輸入完成點選「確定」',

                        },
                        {
                            content: '確認本次變更是否同意授權本公司傳送至其他保險公司申辦相同項目變更',
                            circleOl: [
                                { text: '點選同意，請勾選欲傳送之保險公司及審閱保全契約變更申請轉送暨個資蒐集同意書，並點選☐已閱讀並同意以上「保全契約變更申請轉送暨個資蒐集同意書」之告知事項，點選『下一步』' },
                                { text: '點選不同意，即進入確認輸入資料頁' }
                            ],

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入輸入動態密碼頁' },
                            ],

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '電子通知單服務',
                    code: 'B4',
                    grayContent: {
                        title: '提供項目如下：',
                        ol: [
                            {
                                text: '申請/終止以電子郵件或行動電話寄送各項送金單或通知單。'
                            }
                        ],
                        otherText: [
                            {
                                text: '單項變更預計30分鐘內完成'
                            }
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '依欲申請之保單類別點選「傳統型保單」或「投資型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「電子通知單服務」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '「電子通知單服務」相關重要警語，閱讀完成請點選「確定」',

                        },
                        {
                            content: '輸入變更內容，輸入完成點選「下一步」',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入輸入動態密碼頁' },
                            ],

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '要保人指定匯款帳戶',
                    code: 'B5',
                    grayContent: {
                        title: '',
                        ol: [
                            {
                                text: '要保人匯款帳號約定，指定生效後，未來給付予要保人之各項款項或保險給付有未指定帳號者，得逕匯入此帳號。'
                            },
                        ],
                        otherText: [
                            {
                                text: '單項變更預計30分鐘內完成'
                            }
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '依欲申請之保單類別點選「傳統型保單」或「投資型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「要保人指定匯款帳戶」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '輸入變更內容，輸入完成點選「下一步」',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入輸入動態密碼頁' },
                            ],

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '受益人匯款帳號約定/變更',
                    code: 'B6',
                    grayContent: {
                        title: '',
                        ol: [
                            {
                                text: '受益人匯款帳戶約定，指定生效後，未來給付予該受益人之保險金給付，有未指定者，得逕予匯入同一人已指定之帳戶。'
                            },

                        ],
                        otherText: [
                            {
                                text: '單項變更預計30分鐘內完成'
                            },
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '依欲申請之保單類別點選「投資型保單」或「傳統型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「受益人匯款帳號約定/變更」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '輸入變更內容，輸入完成點選「下一步」',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入輸入動態密碼頁' },
                            ],

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '被保險人指定匯款帳戶',
                    code: 'B7',
                    grayContent: {
                        title: '',
                        ol: [
                            {
                                text: '被保險人匯款帳戶約定，指定生效後，未來給付予被保險人之各項保險給付有未指定帳戶者，例如年金、無理賠回饋保險金…等，得逕予匯入本帳號。'
                            },

                        ],
                        otherText: [
                            {
                                text: '單項變更預計30分鐘內完成'
                            },
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '依欲申請之保單類別點選「投資型保單」或「傳統型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「被保險人指定匯款帳戶」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '輸入變更內容，輸入完成點選「下一步」',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入輸入動態密碼頁' },
                            ],

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '申請電子通知單',
                    code: 'multiENotify',
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '點選申請電子通知單' }
                            ],

                        },
                        {
                            content: '確認行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '「電子通單服務」相關重要警語，閱讀完成請點選「確定」',

                        },
                        {
                            content: '輸入變更內容，輸入完成點選「下一步」',

                        },
                        {
                            content: '申請電子通單服務，彈窗提示進行”行動電話”及”電子信箱”全面更新文字，取消變更，請點選「取消」、確認無誤，請點選「確認」',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '確認無誤，點選「確定」，進入輸入動態密碼頁' },
                            ],

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
            ],
        },
        {
            label: '契約內容',
            value: 'contract',
            list: [
                {
                    title: '繳別變更',
                    code: 'B1',
                    grayContent: {
                        title: '提供辦理繳別變更。',
                        otherText: [
                            {
                                text: '單項變更預計30分鐘內完成'
                            },
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '點選「傳統型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「繳別變更」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '「繳別變更」之相關警語，閱讀完成請點選「確定」',

                        },
                        {
                            content: '輸入變更內容，輸入完成點選「下一步」',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入選擇補/退費方式頁' },
                            ],

                        },
                        {
                            content: '選擇欲補費方式，選擇完成後點選「下一步」，進入輸入動態密碼頁',

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '減少保單價值準備金',
                    code: 'AE',
                    grayContent: {
                        title: '提供辦理減少保單價值準備金。',
                        otherText: [
                            {
                                text: '單項變更預計30分鐘內完成'
                            },
                        ]

                    },
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '依欲申請之保單類別點選「投資型保單」或「傳統型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「減少保單價值準備金」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '「減少保單價值準備金」之相關警語，閱讀完成請點選「確定」',

                        },
                        {
                            content: '輸入變更內容，輸入完成點選「下一步」',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入選擇補/退費方式頁' },
                            ],

                        },
                        {
                            content: '選擇欲退費方式，選擇完成後點選「下一步」，進入輸入動態密碼頁',

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
                {
                    title: '清償自動墊繳本息',
                    code: 'C2',
                    stepOl: [
                        {
                            content: '進入線上交易專區首頁',
                            circleOl: [
                                { text: '點選保單變更' },
                                { text: '點選「傳統型保單」' }
                            ],

                        },
                        {
                            content: '點選欲辦理變更之保單號碼',

                        },
                        {
                            content: '點選變更項目「清償自動墊繳本息」，按『下一步』',

                        },
                        {
                            content: '確認此保單之行動電話及E-mail是否為最新資訊，若同時辦理變更，請點選「我要變更」；確認無誤，請點選「確定」',

                        },
                        {
                            content: '「清償自動墊繳本息」之相關警語，閱讀完成請點選「確定」',

                        },
                        {
                            content: '輸入變更內容，輸入完成點選「下一步」',

                        },
                        {
                            content: '確認輸入資料',
                            circleOl: [
                                { text: '若須修改可點選「返回修改」、若欲刪除本項變更，可點選「刪除變更」' },
                                { text: '請勾選○同意或○不同意通知保單原招攬人員' },
                                { text: '若欲加入其他變更項目，可點選「加入其他變更」' },
                                { text: '確認無誤，點選「確定」，進入選擇補/退費方式頁' },
                            ],

                        },
                        {
                            content: '選擇欲補費方式，選擇完成後點選「下一步」，進入輸入動態密碼頁',

                        },
                        {
                            content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                        },
                        {
                            content: '輸入動態密碼後，請點選「確定」，本次變更申請即委託受理成功',

                        },
                        {
                            content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                        },
                    ]
                },
            ],
        },
        {
            label: '繳費變更',
            value: 'payment',
            list: [{
                title: '網銀帳密電子化繳費授權',
                code: 'ACH_B',
                grayContent: {
                    title: '依可辦理保單提供申請金融機構電子化繳費授權，線上申請後，系統畫面自動導轉至申請授權扣款之銀行網銀頁面，請保費授權人立即輸入網銀帳號及密碼進行驗證，並確認網銀頁面之銀行帳號與線上交易填寫之授權扣款銀行帳號需相同。',
                    reminderTitle: '注意事項：',
                    reminder: [
                        {
                            text: '1. 保費授權人限要保人本人。'
                        },
                        {
                            text: '2. 授權保單號碼之要保人須於本保單留有行動電話。'
                        },
                        {
                            text: '3. 授權人須有該銀行之網路銀行帳號及密碼。'
                        },
                        {
                            text: '4. 台北富邦銀行適用台幣及外幣；其它銀行僅限台幣。'
                        }
                    ]
                },
                stepOl: [
                    {
                        content: '進入線上交易專區首頁',
                        circleOl: [
                            { text: '點選「繳費方式變更」' },
                            { text: '點選「申請金融機構電子化繳費授權」' }
                        ],

                    },
                    {
                        content: '點選授權方式「網銀帳密驗證」',

                    },
                    {
                        content: '點選欲授權銀行及保單號碼，按「下一步」',

                    },
                    {
                        content: '請詳閱「續期金融機構轉帳授權約定條款」，閱讀完成請點選「本人已閱讀並同意」。',

                    },
                    {
                        content: '輸入授權銀行帳號，輸入完成點選「下一步」',

                    },
                    {
                        content: '確認輸入資料',
                        circleOl: [
                            { text: '若須修改可點選「返回修改授權資料」或「返回修改保單資訊」' },
                            { text: '確認無誤，點選「確定」，進入處理結果頁' }
                        ],

                    },
                    {
                        content: '系統畫面將自動導轉至申請授權扣款之銀行網銀頁面，請點選「確定」，登入銀行網銀進行驗證，請於系統導轉後20分鐘內完成驗證作業。',
                        otherText: [
                            { text: '註1.以台北富邦銀行為例', imgNumber: '07_1' },
                            { text: '註2.非台北富邦銀行接續Step7點選「確定」後，將顯示連結帳號資訊之視窗，請點選「下一步」，導轉至其它網路銀行進行驗證（登入及驗證規範依各家網路銀行約定為準）', imgNumber: '07_2' },
                        ],

                    },
                    {
                        content: '授權驗證',
                        circleOl: [
                            { text: '執行Step7銀行網銀驗證作業時，不可關閉授權驗證中畫面，銀行網銀驗證完成後，系統會顯示處理結果（授權成功或失敗）' },
                            { text: '自動導轉至銀行網銀頁面不慎關閉，請按「授權連結」，系統將再次導轉至申請授權扣款之銀行網銀頁面，並於剩餘時間內完成驗證作業' }
                        ],

                    },
                    {
                        content: '處理結果',
                        circleOl: [
                            { text: '若網銀帳密驗證成功，欲用同一個銀行帳號授權其他保單號碼，請點選「繼續授權下一張保單」' },
                            { text: '若網銀帳密驗證失敗，無「繼續授權下一張保單」按鈕，請點選「回首頁」重新申請電子化繳費授權。' },
                            { text: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」' }
                        ],

                    }
                ]
            },
            {
                title: '申請信用卡授權',
                code: 'creditCardAuth',
                grayContent: {
                    otherText: [
                        {
                            text: '1.台幣保單：授權人(即要保人)持有國內發卡機構所發行之VISA、MASTER、JCB、AE卡者，皆可辦理繳交本公司指定的各商品續期保險費，注意事項：'
                        },
                        {
                            text: ' (1)原安泰有效保單之部分傳統型壽險商品，僅開放特定信用卡（台北富邦、永豐、星展、兆豐、玉山）繳交續期保險費'
                        },
                        {
                            text: ' (2)投資型商品限用台北富邦信用卡'
                        },
                        {
                            text: '2.外幣保單：不適用信用卡繳費。'
                        },
                    ]

                },
                stepOl: [
                    {
                        content: '進入線上交易專區首頁',
                        circleOl: [
                            { text: '點選「繳費方式變更」' },
                            { text: '點選「申請信用卡授權」' }
                        ],

                    },
                    {
                        content: '確認行動電話及E-mail是否為最新資訊，若要變更，請點選「變更」；確認無誤，請點選「確定」',

                    },
                    {
                        content: '閱讀「續期信用卡授權約定條款」，閱讀完成點選「本人已審閱並同意」',

                    },
                    {
                        content: '輸入信用卡資料，輸入完成點選「下一步」',

                    },
                    {
                        content: '選擇保單，輸入完成點選「下一步」',

                    },
                    {
                        content: '確認輸入資料',
                        circleOl: [
                            { text: '若須修改可點選「返回修改」' },
                            { text: '確認無誤，點選「確定」，進入輸入動態密碼頁' }
                        ],

                    },
                    {
                        content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                    },
                    {
                        content: '輸入動態密碼後，請點選「確定」，本次信用卡效期延長申請即受理完成',

                    },
                    {
                        content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                    }
                ]
            },
            {
                title: '信用卡效期延長',
                code: 'creditCardExp',
                stepOl: [
                    {
                        content: '進入線上交易專區首頁',
                        circleOl: [
                            { text: '點選「繳費方式變更」' },
                            { text: '點選「信用卡效期延長」' }
                        ],

                    },
                    {
                        content: '確認行動電話及E-mail是否為最新資訊，若要變更，請點選「變更」；確認無誤，請點選「確定」',

                    },
                    {
                        content: '點選欲延長效期之信用卡，按「下一步」',

                    },
                    {
                        content: '輸入信用卡之有效月/年，輸入完成點選「下一步」',

                    },
                    {
                        content: '確認輸入資料',
                        circleOl: [
                            { text: '若須修改可點選「返回修改」；若欲刪除本項變更，可點選「刪除變更」' },
                            { text: '確認無誤，點選「確定」，進入輸入動態密碼頁' }
                        ],

                    },
                    {
                        content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                    },
                    {
                        content: '輸入動態密碼後，請點選「確定」，本次信用卡效期延長申請即受理完成',

                    },
                    {
                        content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                    }
                ]
            },
            {
                title: '申請自行繳費',
                code: 'multiPayChange',
                stepOl: [
                    {
                        content: '進入線上交易專區首頁',
                        circleOl: [
                            { text: '點選「繳費方式變更」' },
                            { text: '點選「申請自行繳費」' }
                        ],

                    },
                    {
                        content: '確認行動電話及E-mail是否為最新資訊，若要變更，請點選「變更」；確認無誤，請點選「確定」',

                    },
                    {
                        content: '自行繳費之注意事項，請點選「確定」',

                    },
                    {
                        content: '點選欲申請自行繳費之保單號碼，按「下一步」',

                    },
                    {
                        content: '確認輸入資料',
                        circleOl: [
                            { text: '若須修改可點選「返回修改」；若欲刪除本項變更，可點選「刪除變更」' },
                            { text: '確認無誤，點選「確定」，進入輸入動態密碼頁' }
                        ],

                    },
                    {
                        content: '點選「發送動態密碼」，系統將於1~2分鐘內傳送動態密碼',

                    },
                    {
                        content: '輸入動態密碼後，請點選「確定」，本次自行繳費申請即受理完成',

                    },
                    {
                        content: '若欲下載申請紀錄可點選「下載申請紀錄」；若欲查看保單其他申請紀錄可點選「申請紀錄」',

                    }
                ]
            }],
        },
    ]
};

Object.freeze(IllustrationContent);
export default IllustrationContent;
